import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import HomePage from '@/pages/HomePage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import UtmPage from '@/pages/UtmPage.vue'
import SmsPage from '@/pages/SmsPage.vue'
import AdminPage from '@/pages/AdminPage.vue'
import ThemeImagesPage from '@/pages/ThemeImagesPage.vue'
import TestPage from '@/pages/TestPage.vue'
import PotokTelegramApp from '@/pages/PotokTelegramApp.vue'
import KinescopePage from '@/pages/KinescopePage.vue'
import JtbdConstructor from '@/pages/JtbdConstructor.vue'
import TranscriberUploadPage from '@/pages/TranscriberUploadPage.vue'
import WisdomPage from '@/pages/WisdomPage.vue'
import HtmlToPdfPage from '@/pages/HtmlToPdfPage.vue'
import LeadsPage from '@/pages/LeadsPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import RagMonitorPage from '@/pages/RagMonitorPage.vue'
import RagDashboard from '@/pages/rag-monitor/RagDashboard.vue'
import ExecutionLogsPage from '@/pages/rag-monitor/ExecutionLogsPage.vue'
import SessionsPage from '@/pages/rag-monitor/SessionsPage.vue'
import SessionChatPage from '@/pages/rag-monitor/SessionChatPage.vue'
import AgentChatPage from '@/pages/AgentChatPage.vue'
import DealExportsPage from '@/pages/DealExportsPage.vue'
import SheetExportsPage from '@/pages/SheetExportsPage.vue'
import WisdomAdminPage from '@/pages/WisdomAdminPage.vue'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/login/:rid',
      name: 'register',
      component: LoginPage
    },
    {
      path: '/utm',
      name: 'utm',
      component: UtmPage,
      meta: { requiresAuth: true, requiresPermission: { page: 'utm_page', permission: 'view' } }
    },
    {
      path: '/utm/:rid',
      name: 'utmid',
      component: UtmPage,
      meta: { requiresAuth: true, requiresPermission: { page: 'utm_page', permission: 'view' } }
    },
    {
      path: '/sms',
      name: 'sms',
      component: SmsPage,
      meta: { requiresAuth: true, requiresPermission: { page: 'sms_page', permission: 'view' } }
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminPage,
      meta: { requiresAuth: true, requiresAdminAccess: true }
    },
    {
      path: '/theme-images',
      name: 'theme-images',
      component: ThemeImagesPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'theme_images', permission: 'view' }
      }
    },
    {
      path: '/potok',
      name: 'potok',
      component: PotokTelegramApp,
      beforeEnter: () => {
        if (!window.Telegram && !window.Telegram?.WebApp?.initData) {
          alert('Доступ только через Telegram Web App')
          return false
        }
        return true
      }
    },
    {
      path: '/test',
      name: 'test',
      component: PotokTelegramApp
    },
    {
      path: '/test1',
      name: 'test1',
      component: TestPage
    },
    {
      path: '/kinescope',
      name: 'kinescope',
      component: KinescopePage,
      meta: { requiresAuth: true, requiresPermission: { page: 'kinescope_page', permission: 'view' } }
    },
    {
      path: '/jtbd/:id?',
      name: 'jtbd',
      component: JtbdConstructor,
      meta: { requiresAuth: true, requiresPermission: { page: 'jtbd_page', permission: 'view' } }
    },
    {
      path: '/wisdom',
      name: 'wisdom-base',
      component: WisdomPage,
      meta: { 
        requiresAuth: true, 
        requiresPermission: { page: 'wisdom_base', permission: 'view' }
      }
    },
    {
      path: '/tools/transcriber/upload',
      name: 'transcriber-upload',
      component: TranscriberUploadPage
    },
    {
      path: '/tools/html-to-pdf',
      name: 'html-to-pdf',
      component: HtmlToPdfPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'html_to_pdf', permission: 'view' }
      }
    },
    {
      path: '/leads',
      name: 'leads-page',
      component: LeadsPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'forms_leads', permission: 'view' }
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard-page',
      component: DashboardPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/agent',
      name: 'agent-chat',
      component: AgentChatPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'agent_page', permission: 'view' }
      }
    },
    {
      path: '/deal-exports',
      name: 'deal-exports',
      component: DealExportsPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'deal_exports', permission: 'view' }
      }
    },
    {
      path: '/sheet-exports',
      name: 'sheet-exports',
      component: SheetExportsPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'sheet_exports', permission: 'view' }
      }
    },
    {
      path: '/wisdom-base',
      name: 'wisdom-lessons-admin',
      component: WisdomAdminPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'wisdom_base', permission: 'view' }
      }
    },
    {
      path: '/rag-monitor',
      component: RagMonitorPage,
      meta: {
        requiresAuth: true,
        requiresPermission: { page: 'wisdom_base', permission: 'view' }
      },
      children: [
        { path: '', redirect: { name: 'rag-monitor-dashboard' } },
        {
          path: 'dashboard',
          name: 'rag-monitor-dashboard',
          component: RagDashboard
        },
        {
          path: 'logs',
          name: 'rag-monitor-logs',
          component: ExecutionLogsPage
        },
        {
          path: 'sessions',
          name: 'rag-monitor-sessions',
          component: SessionsPage
        },
        {
          path: 'sessions/:id',
          name: 'rag-monitor-session-chat',
          component: SessionChatPage
        }
      ]
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const store = useUserStore()

  // На главной хедер показывает меню по user — подгружаем user до первого рендера
  if (to.path === '/' && store.token && !store.user) {
    await store.checkAuth()
  }

  // Проверяем авторизацию только если роут требует этого
  if (to.meta.requiresAuth) {
    const isAuthenticated = await store.checkAuth()
    
    if (!isAuthenticated) {
      next({ 
        path: '/login', 
        query: { redirect: to.fullPath } 
      })
      return
    }

    // Проверяем роли (для маршрутов, которые ещё используют role-based доступ)
    if (to.meta.allowedRoles && !store.hasRole(to.meta.allowedRoles)) {
      next({ 
        path: '/', 
        query: { redirect: to.fullPath } 
      })
      return
    }

    // Проверяем per-page permission, если указано
    if (to.meta.requiresPermission) {
      const { page, permission } = to.meta.requiresPermission
      if (!store.hasPermission(page, permission)) {
        next({ 
          path: '/', 
          query: { redirect: to.fullPath } 
        })
        return
      }
    }

    if (to.meta.requiresAdmin && !store.isAdmin) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
      return
    }

    // Проверяем доступ к админке (админ или пользователь с разрешением view на admin_panel)
    if (to.meta.requiresAdminAccess && !store.hasAdminAccess) {
      next({ 
        path: '/', 
        query: { redirect: to.fullPath } 
      })
      return
    }
  } else if (to.path === '/login' && store.isAuthenticated) {
    // Если пользователь авторизован и пытается зайти на страницу логина
    next({ path: '/' })
    return
  }
  
  next()
})

export default router